<template>
  <custom-editor v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor';
Quill.debug('error');
const Link = Quill.import('formats/link');
class MyLink extends Link {
  static create(value) {
    const node = super.create(value);
    value = this.sanitize(value);
    if (!value.startsWith('http') && !value.startsWith('//')) {
      value = '//' + value;
    }
    node.setAttribute('href', value);
    return node;
  }
}

Quill.register(MyLink);

export default {
  components: {
    'custom-editor': VueEditor
  }
};
</script>
